import React from 'react'
import {useUrlFriendlyToParameters} from 'helpers/urlFriendly';
import Label, { useLabels } from 'components/general/Label';

export default function HorseBioData({data}) {
  const {  mirs_language, } = useUrlFriendlyToParameters()
  const fLabel = useLabels()


  if (mirs_language !== "ENG" && mirs_language !== 'HIN') {
    return (<b>{fLabel({ data: 'LabelExtendedProfile' })}</b>);
  }

  let string = data?.horse?.horseBio?.interest?.majorAchievements
  const majorAchievementsString = string?.replace(/<\/?[^>]+(>|$)/g, "");

  return(
    <>
      {data && data?.horse && data?.horse?.horseBio &&
        <>
          <div className="mb-2">
          <a name="bio"><h2 className="wrsBiosDetail__h2"><Label data="HeaderBiographicalInformation"/></h2></a>
                {data?.horse?.horseBio?.dam && <div className="pt-2"><b><Label data="LabelDam" />:&nbsp;</b> {data?.horse?.horseBio?.dam}</div>}
                {data?.horse?.horseBio?.sireDam && <div className="pt-2"><b><Label data="HeaderSireDam" />:&nbsp;</b> {data?.horse?.horseBio?.sireDam}</div>}
                {data?.horse?.horseBio?.breeder && <div className="pt-2"><b><Label data="LabelBreeder" />:&nbsp;</b> {data?.horse?.horseBio?.breeder}</div>}
                {data?.horse?.horseBio?.studBook && <div className="pt-2"><b><Label data="LabelStudbook" />:&nbsp;</b> {data?.horse?.horseBio?.studBook}</div>}
                {data?.horse?.horseBio?.height && <div className="wrsNoc pt-2"><b><Label data="HeaderHeightCM"/>:&nbsp;</b> {data?.horse?.horseBio?.height}</div>}
                {data?.horse?.horseBio?.countryofBirth && <div className=" pt-2"><b><Label data="LabelBirthCountry"/>:&nbsp;</b> {data?.horse?.horseBio?.countryofBirth}</div>}
          </div>
        </>
      }    
      {data?.horse?.horseBio ?
        <>
          {(mirs_language !== "ENG" && mirs_language !== 'HIN') ?
            <>
              <a name="generalInfo"><h2 className="wrsBiosDetail__h2"><Label data="HeaderGeneralInformation" /></h2></a>
              <b><Label data="LabelExtendedProfile" /></b>
            </>
          :
            <div className="mb-2">
              <a name="generalInfo"><h2 className="wrsBiosDetail__h2"><Label data="HeaderGeneralInformation"/></h2></a>
              {data?.horse?.horseBio?.interest?.majorAchievements && <div className="wrsNoc pt-2"><b><Label data="HeaderMajorAchievements" />:</b></div>}
              {data?.horse?.horseBio?.interest?.majorAchievements && <div>{majorAchievementsString}</div>}
            </div>
          }
        </>
        :
        <>
          {/* <a name="generalInfo"><h2 className="wrsBiosDetail__h2"><Label data="HeaderGeneralInformation" /></h2></a>
          <b><Label data="LabelNoDataAvailable"/> </b> */}
        </>
      }    
    </>
  )
}